






















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { BankAccount } from '@/store/mangoPay/types';

import Modal from '@/components/_common/Modal.vue';

@Component({
  name: 'create-mandate',
})
export default class CreateMandate extends Vue {
  @Action('mangoPay/createMandate') createMandate: Function;
  @Action('mangoPay/fetchUserMandates') fetchUserMandates: Function;

  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Getter('mangoPay/getBankAccountById') getBankAccountById?: Function;
  @Getter('mangoPay/loadingBankAccounts') loadingBankAccounts?: Boolean;

  isLoading: Boolean = false;

  error: string = '';
  checkedOptions: Array<string> = [];

  accountId: string | null = null;
  bankAccount: BankAccount = null;

  created() {
    this.accountId = this.$route.params.accountId;
    this.bankAccount = this.getBankAccountById(this.accountId);
  }

  onCreateSubmit() {
    this.isLoading = true;
    this.createMandate(this.accountId)
      .then(this.onCreateSuccess)
      .catch(({ data }) => {
        this.error = data.message ? data.message : this.$t('forms.error', { context: 'generic' });
      })
      .finally(() => (this.isLoading = false));
  }

  async onCreateSuccess(data) {
    if (data.RedirectURL) {
      window.location.href = data.RedirectURL;
    }

    await this.fetchUserMandates();
    this.$router.replace(`/bank-account/${this.accountId}`);
  }

  get hasAgreed() {
    return this.checkedOptions.length > 1;
  }
}
